import { render, staticRenderFns } from "./LPGKeagenan.vue?vue&type=template&id=6c73933e"
import script from "./LPGKeagenan.vue?vue&type=script&lang=js"
export * from "./LPGKeagenan.vue?vue&type=script&lang=js"
import style0 from "./LPGKeagenan.vue?vue&type=style&index=0&id=6c73933e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports